wbApp.factory('compensationGroupSvc', ['$resource', '$q', 'repositorySvc',
    function ($resource, $q, repositorySvc) {
        var CompensationGroup = $resource('/Api/CompensationGroups/:id', {}, {
            'getLookup': { method: 'GET', isArray: true, url: '/Api/CompensationGroups/GetLookup' },
            'getAll': { method: 'GET', isArray: true, url: '/Api/CompensationGroups/GetAll' },
            'update': { method: 'POST', url: '/Api/CompensationGroups/Update' },
            'insert': { method: 'POST', url: '/Api/CompensationGroups/Insert' },
            'delete': { method: 'POST', url: '/Api/CompensationGroups/Delete' }
        });

        var compensationGroupsBrief;
        var compensationGroups;

        function getLookup() {
            if (!compensationGroupsBrief) {
                compensationGroupsBrief = repositorySvc.customGet('getLookup', CompensationGroup);
            }

            return compensationGroupsBrief;
        }

        function getDefaultAsync() {
            var all = getLookup();

            return $q(function (resolve, reject) {
                all.$promise.then(function (data) {
                    var def = _.find(data, { isDefault: true, active: true, isDeleted: false });
                    if (!def && data.length > 0) {
                        def = data[0];
                    }
                    resolve(def);
                }, function (reason) {
                    reject(reason);
                });
            });
        }

        function getLookupActiveAsync(IDstoInclude) {
            var all = getLookup();
            var filtered = [];

            var deferred = $q.defer();
            filtered.$promise = deferred.promise;

            all.$promise.then(function (data) {
                angular.forEach(data, function (value, key) {
                    if ((!value.isDeleted && value.active) || (!!IDstoInclude && _.indexOf(IDstoInclude, value.id) !== -1)) {
                        filtered.push(value);
                    }
                });
                deferred.resolve(filtered);
            }, function (reason) {
                deferred.reject(reason);
            });

            return filtered;
        }

        function get(id) {
            if (compensationGroupsBrief) {
                for (var i = 0; i < compensationGroupsBrief.length; i++) {
                    var sc = compensationGroupsBrief[i];
                    if (sc.id === id) {
                        return sc;
                    }
                }
            }
            return null;
        }


        function getAsync(id) {
            var deferred = $q.defer();

            getLookup().$promise.then(function (sem) {
                angular.forEach(sem, function (value, key) {
                    if (value.id == id) {
                        deferred.resolve(value);
                        return;
                    }
                })
                deferred.resolve(null);
            }, function (errorResult) {
                deferred.reject(errorResult);
            });

            return deferred.promise;
        }

        function createNew() {
            return {};
        }

        function getAllAsync(reload) {
            compensationGroups = repositorySvc.customGet('getAll', CompensationGroup);

            return compensationGroups;
        }

        function insert(data, successCallback, errorCallback) {

            function success(entity) {
                compensationGroupsBrief = null;
                if (successCallback) {
                    successCallback(entity);
                }
            }
            
            return repositorySvc.insert(
                CompensationGroup,             // $resource
                compensationGroups,            // collection
                data,                          // entity
                success,
                errorCallback,
                'compensationGroupID');
        }

        function update(data, successCallback, errorCallback) {

            function success(entity) {
                compensationGroupsBrief = null;
                if (successCallback) {
                    successCallback(entity);
                }
            }

            return repositorySvc.update(
                CompensationGroup,          // $resource
                compensationGroups,         // collection
                data,                       // entity
                success,
                errorCallback,
                'compensationGroupID');
        }

        function remove(data, successCallback, errorCallback) {

            function success(entity) {
                compensationGroupsBrief = null;
                if (successCallback) {
                    successCallback(entity);
                }
            }

            return repositorySvc.remove(
                CompensationGroup,          // $resource
                compensationGroups,         // collection
                data,                       // entity
                success,
                errorCallback,
                { compensationGroupID: data.compensationGroupID },
                'compensationGroupID');
        }

        return {
            getLookup: getLookup,
            get: get,
            getAsync: getAsync,
            getAllAsync: getAllAsync,
            insert: insert,
            update: update,
            remove: remove,
            createNew: createNew,
            getLookupActiveAsync: getLookupActiveAsync,
            getDefaultAsync: getDefaultAsync
        }
    }]);